import { http } from "../../utils/http";
import { ProfileFormType } from "../../components/pages/profile/Profile";

// interface

interface ChangePasswordType {
  oldPassword: string;
  newPassword: string;
}

interface UploadImageProfileType {
  files: File;
}
// end interface

export const getUserProfile = () => {
  return http.get(`/core/api/managements/1.0/account/profile`, undefined, true);
};

export const UpdateUserProfile = (payload: ProfileFormType) => {
  return http.put(`/core/api/managements/1.0/account/profile`, payload, true);
};

export const ChangePassword = (payload: ChangePasswordType) => {
  return http.post(
    `/core/api/managements/1.0/account/change-password`,
    payload,
    true,
    false
  );
};

export const UploadUserProfile = (payload: UploadImageProfileType) => {
  return http.post(
    `/core/api/managements/1.0/files`,
    payload,
    true,
    false,
    true
  );
};

export const ViewImage = (fileId: string) => {
  return `${process.env.REACT_APP_API_VALLARIS}/core/api/managements/1.0/files/${fileId}/view`;
};
